import { ChipProps } from '@mui/material';
import { useGetConductTypesForSchoolQuery } from '@schooly/api';
import { Spin, TagSelect } from '@schooly/style';
import { FC, useMemo } from 'react';

export type ConductTypeTagSelectProps = {
  id: string;
  schoolId: string;
} & ChipProps;

export const ConductTypeTagSelect: FC<ConductTypeTagSelectProps> = ({ id, schoolId, ...props }) => {
  const { data } = useGetConductTypesForSchoolQuery(schoolId, { enabled: !!schoolId });

  const conductType = useMemo(() => data?.find((ct) => ct.id === id), [data, id]);

  return <TagSelect label={conductType ? conductType.name : <Spin />} {...props} />;
};
